/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from './index';
import { AnyAction } from 'redux';

type Data = {
  user: unknown,
  actions: {
    utrs: unknown[],
    frameworkUtrs: unknown[],
    surveys: unknown[]
  }
}
type State = ReduxStateLoadable<Data, unknown[]>
const getDefaultState = (): State => ({
  data: [],
  loaded: false,
  errored: false,
  errorMessage: ''
});

const userTrackers = (
  state = getDefaultState(),
  action: AnyAction,
): State => {
  switch (action.type) {
    case actionTypes.LOADING_USER_TRACKER_ACTIONS:
    case actionTypes.NO_DATA_USER_TRACKER_ACTIONS:
      return {
        ...state,
        data: [],
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.ERROR_USER_TRACKER_ACTIONS:
      return {
        ...state,
        data: [],
        loaded: false,
        errored: true,
        lastUpdated: Date.now(),
        errorMessage: action.errorMessage
      }
    case actionTypes.LOADED_USER_TRACKER_ACTIONS:
      return {
        ...state,
        data: action.data,
        loaded: true,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.UNLOAD_USER_TRACKER_ACTIONS:
      return {
        ...state,
        data: [],
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    default:
      return state;
  }
}

export default userTrackers;
